import Promise from 'bluebird'
import superagent from 'superagent'

export default function (url) {
  return new Promise(function (resolve, reject) {
    superagent
      .get('/api/pageinfo.php')
      .query({ url })
      .send()
      .end(function (err, result) {
        if (err) {
          reject(err);
        } else {
          if (result.body && result.body.success) {
            resolve(result.body)
          } else {
            reject(new Error(result.body.message))
          }
        }
      })
  })
}


// WEBPACK FOOTER //
// ./src/shared/pageinfo.js